export const izradi_vlastiti_ugovor = {
    templateId: 50,
    category: 12,
    templateTitle: "Izradi vlastiti ugovor",
    templateDescription: `<p>Pomoću ovog dokumenta možete samostalno kreirati vlastiti ugovor.</p>`,
    description: `
    <h5><strong>OPIS DOKUMENTA</strong></h5>
    <p>Ovim dokumentom kreirate vlastite predloške ugovora.</p>
    <br>
    <p> U članak 1. upisujete željeni tekst te potom dodajete preostale članke i upisujete njihov sadržaj.</p>
    <br>
  `,
    sides: [
        {
            prefix: '',
            signature: 'Za __________________________:',
            inputs: [{
                type: "input",
                required: true,
                placeholder: "Poslovni subjekt",
              },
              {
                type: "input",
                required: true,
                placeholder: "Ulica i kućni broj",
              },
              {
                type: "input",
                required: true,
                placeholder: "Mjesto",
              },
              {
                type: "input",
                required: true,
                placeholder: "OIB",
              },
              {
                type: "input",
                placeholder: "Zastupa",
                inSignature: true,
              },
              {
                type: "input",
                placeholder: "Funkcija",
                inSignature: true,
                }],
            suffix: ' (u daljnjem tekstu:__________________________)',
            delimiter: `i`
        },
        {
            prefix: '',
            signature: 'Za __________________________:',
            inputs: [{
                type: "input",
                required: true,
                placeholder: "Poslovni subjekt",
              },
              {
                type: "input",
                required: true,
                placeholder: "Ulica i kućni broj",
              },
              {
                type: "input",
                required: true,
                placeholder: "Mjesto",
              },
              {
                type: "input",
                required: true,
                placeholder: "OIB",
              },
              {
                type: "input",
                placeholder: "Zastupa",
                inSignature: true,
              },
              {
                type: "input",
                placeholder: "Funkcija",
                inSignature: true,
              }],
            suffix: ' (u daljnjem tekstu:__________________________),',
        }
    ],

    headline: 'zaključuju sljedeći',
    title: 'UGOVOR',

    articles: [
        {
            title: '',
            mandatory: true,
            statements: [
                {
                    type: 'text',
                    required: true,
                    mandatory: true,
                    editable: true,
                    content: '',  
                    placeholder: 'Ovdje, te nadalje u ostale članke (koje dodajete samostalno) upisujete tekst po želji...',
                    value: '',
                }],
        },
        {
            mandatory: true,
            static: true,
            type: 2, // date and place
            statements: [
              {
                type: "input",
                mandatory: true,
                parts: [
                  {
                    type: "text",
                    content: "U"
                  },
                  {
                    type: "input",
                    value: "",
                    placeholder: "Upišite mjesto.",
                    required: true,
                  },
                  {
                    type: "text",
                    content: ", dana"
                  },
                  {
                    type: "date",
                    value: new Date(),
                    required: true
                  },
                  {
                    type: "text",
                    content: "godine."
                  }
                ]
              },
            ]
          },
        {
            mandatory: true,
            static: true,
            type: 3,  // signatures
            statements: [],
        },
    ],
};



// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/50_izradi_vlastiti_ugovor.ts